import { Menus } from "./Menus";
import { Link } from "react-router-dom";

export function Sidebar() {
  return (
    <div
      className="pt-[5rem] fixed duration-300 h-full w-[10rem] bg-white shadow-md z-10"
    >
      <ul className="flex flex-col fixed justify-center w-[10rem] pt-3">
        {Menus.map((menu, index) => (
          <li key={index} className="text-gray-900 text-sm cursor-pointer p-2 hover:bg-gray-300 rounded-sm mt-2">
            <Link to={menu.src} className="flex items-center gap-x-4">
              {menu.icon}
              <span className="origin-left w-[90px] duration-200">{menu.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
